import React, { Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';

import PreLoaderWidget from 'components/Loader';
import VerticalLayout from 'components/AppLayout/Layouts/Vertical';

import ProtectedRoutes from './ProtoctedRoutes';
import useAuthorize from 'hooks/useAuthorize';

const Authorization = React.lazy(() => import('routes/Authorization'));

const ProtectedAppRoutes = () => (
    <VerticalLayout>
        <ProtectedRoutes/>
    </VerticalLayout>
);

const Routes = () => {
    const { isAuthorized } = useAuthorize();
    return (
        <Suspense fallback={<PreLoaderWidget/>}>
            <Switch>
                <Route path="/account" component={Authorization}/>
                {
                    (process.env.AZURE_SSO_LOGIN_ENABLED === 'true' && useIsAuthenticated) && (
                        <ProtectedAppRoutes/>
                    )
                } {
                (localStorage.getItem('token') !== null && process.env.AZURE_SSO_LOGIN_ENABLED === 'false') && (
                    <ProtectedAppRoutes/>
                )
            }
            </Switch>
        </Suspense>
    );
};

export default Routes;
